import { toast } from "react-toastify";
import { fetcheditRatingGroupFailure, fetcheditRatingGroupSuccess } from "./reducer";
import { setEditSuccessMessage } from "../../toastMessage/action";
import { RATING_GROUP_API } from "../../constants/constants";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { getAllRatingGroup } from "../thunk";

export const editRatingGroup = (jsonObj,ratingGroup,serviceIdentifier, serviceContextID, setLoading,setModalOpen) => async (dispatch) => {
    setLoading(true)
    await determineBaseUrlAndPerformApiCall(`${RATING_GROUP_API}/${ratingGroup}/${serviceIdentifier}/${serviceContextID}`, 'PUT', jsonObj).then((response) => {
        if (response.error) {
            dispatch(fetcheditRatingGroupFailure(response.error.message))
            setLoading(false)
            toast.error(`${response.error.message}`)
        }
        if (!response.error) {
            dispatch(fetcheditRatingGroupSuccess(response))
            dispatch(setEditSuccessMessage(true))
            setModalOpen(false)
            dispatch(getAllRatingGroup(setLoading))
            setLoading(false)
        }
    }).catch((errorResp) => { })
};